var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgApproval = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#approval_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 24.07 17.96 80l49.823-3.66-5.52-56.537L12.5 24.07Z",
  className: "approval_svg__primary"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.153 36.861c-.001-.006-.023-.01-.06-.011a1.26 1.26 0 0 0-.14.004l-24.099 2.012c-.051.005-.099.011-.132.018-.034.008-.05.015-.044.02l.402 2.765c.01.011.462-.027.559-.035h.008l23.922-2c.101-.01.18-.026.177-.038l-.593-2.735ZM22.019 21.413l.817 8.378 30.35-2.818-.826-8.457-30.341 2.897ZM58.35 49.237c-.002-.006-.024-.01-.062-.012-.037 0-.086 0-.138.005l-24.1 2.012c-.05.005-.099.011-.132.018-.033.008-.05.015-.044.02l.402 2.765c.01.011.462-.027.559-.035h.009l23.92-2c.102-.01.181-.026.179-.038l-.594-2.735ZM59.546 61.613c-.001-.006-.023-.01-.06-.012-.038 0-.088 0-.14.005l-24.099 2.012c-.051.004-.099.01-.132.018-.034.008-.05.015-.044.02l.402 2.765c.01.01.462-.027.559-.035h.009l23.92-2.001c.102-.009.181-.025.178-.037l-.593-2.735Z",
  className: "approval_svg__secondary"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.424 17.367 28.922 22.2l16.819-1.562-2.413-4.494-12.904 1.222Z",
  className: "approval_svg__secondary"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.627 49.878.711 7.278 7.41-.59-.717-7.346-7.404.658Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.69 55.759-2.734-2.431.69-2.339 1.897 1.686 4.407-5.547 1.61 2.093-5.87 6.538Z",
  className: "approval_svg__secondary"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.42 37.502.71 7.28 7.41-.59-.717-7.347-7.404.657Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.481 43.383-2.733-2.43.69-2.339 1.897 1.686 4.407-5.547 1.61 2.093-5.87 6.538Z",
  className: "approval_svg__secondary"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.835 62.253.711 7.278 7.41-.59-.717-7.346-7.404.658Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.897 68.134-2.733-2.431.69-2.339 1.897 1.686 4.407-5.547 1.61 2.093-5.87 6.538ZM73.878 5.92l-8.355 8.696 1.828 2.113 9.567-7.295-3.04-3.514ZM62.911 0l-2.255 11.859 2.683.768 4.034-11.349L62.911 0ZM79.776 18.012l-11.93 1.665.136 2.793L80 22.658l-.224-4.646Z",
  className: "approval_svg__secondary"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "approval_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v80H0z"
})))));
export default SvgApproval;